import camposOriginais from './covidDB_strapi_cheatsheet.json';

export function convertProjectData(allProjects) {
  //converts project data from the BE "STRAPI MODEL" to the old model used in the first forum urbano
  //First the structure - then the fields

  let convertedData = [];
  let projectsOldFields = [];

  //structure convert
  allProjects.forEach((project) => {
    let projectObject = {};
    Object.entries(project).forEach(([key, value]) => {
      //  console.log('key, value', key, value);
      if (Array.isArray(value)) {
        //this is an array, inside a project i.e AreasTematicas[]
        value.forEach((item) => {
          if (!projectObject[key]) {
            projectObject[key] = [];
          }
          if (item?.Valor) {
            projectObject[key].push(item.Valor);
          } else {
            //console.log('Not possible to get value from ', key);
          }
        });
      } else {
        // console.log('UPDATED_AT?', key, key === 'updatedAt');
        projectObject[key] = value;
      }
    });
    convertedData.push(projectObject);
  });

  //fields convert
  convertedData.forEach((project, index) => {
    let oldFieldsProject = {};
    Object.entries(project).forEach(([field, value]) => {
      if (camposOriginais.correspondencia_inversa[field]) {
        let oldKey = camposOriginais.correspondencia_inversa[field].key;
        oldFieldsProject[oldKey] = value;
      } else {
        if (field === 'updatedAt' || field === 'createdAt') {
          oldFieldsProject[field] = value;
        }
        //console.log('Failed on ' + field);
      }
    });
    projectsOldFields.push(oldFieldsProject);
  });

  return projectsOldFields;
}

export function convertProjectsBackToStrapiStructure(tempState) {
  //we will change the structuer and the fields (field dictionary)

  let projectStrapiFormat = {};
  Object.entries(tempState).forEach(([oldKey, value]) => {
    // console.log(
    //   'Searching KEY' + oldKey + ' Getting: ',
    //   camposOriginais.correspondencia
    // );
    // console.log(
    //   ' camposOriginais.correspondencia[oldKey].key',
    //   camposOriginais.correspondencia[oldKey].key
    // );

    if (!camposOriginais?.correspondencia[oldKey]?.key) {
      console.log('Key not detected: ', strapiKey);
      return;
    }

    let strapiKey = camposOriginais.correspondencia[oldKey].key; //transform Key

    if (Array.isArray(value)) {
      tempState[oldKey].forEach((stringValueToTransform, index) => {
        if (!projectStrapiFormat[strapiKey]) {
          projectStrapiFormat[strapiKey] = [];
        }

        projectStrapiFormat[strapiKey][index] = {
          Valor: stringValueToTransform
        };
      });
    } else {
      projectStrapiFormat[strapiKey] = value;
    }
  });
  return projectStrapiFormat;
}
/*
       console.log(
          'Searching KEY' + key + ' Getting: ',
          camposOriginais.correspondencia_inversa[key].key
        );
        stringValueToTransform =
          camposOriginais.correspondencia_inversa[key].key; //key from FE to key from strapi
        if (!stringValueToTransform) {
          console.error(
            "Campo '" + key + "' não encontrado no dicionário. Actualizar?"
          );
        }
*/
